import axios from "axios";
import {
    authHeader,
    handleResult,
    handleException,
    globalStore
} from '../helpers';

export const salarySpecificationService = {
    getAll,
    getByDate,
    getVersions,
    getByUser,
    getById,
    create,
    update,
    getDefinitions,
    saveSalaryRow,
    getCalculationData,
    deleteSalaryRow,
    getPdf,
    getZip,
    attest,
    lockToggle,
    getSalaryFile
};

function getById(salarySpecificationId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.get("salaryspecification/" + salarySpecificationId, requestOptions).then(handleResult).catch(handleException);
}

function getVersions(userId, year, month) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.get(`salaryspecification/versions/${userId}/${year}/${month}`, requestOptions).then(handleResult).catch(handleException);
}

function getAll() {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.get("salaryspecification", requestOptions).then(handleResult).catch(handleException);
}

function getByDate(date) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.get(`salaryspecification/date/${date}`, requestOptions).then(handleResult).catch(handleException);
}

function getSalaryFile() {
    return axios({
        url: "salaryspecification/salaryFile",
        method: "GET",
        headers: authHeader(),
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "salaryFile.txt"
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
        return response;
      });
}

function getByUser(userId, year, month) {
    const requestOptions = {
        headers: authHeader()
    };

    var path = `salaryspecification/user/${userId}`;
    if(year) path = `${path}/${year}`;
    if(month) path = `${path}/${month}`;

    return axios.get(path, requestOptions).then(handleResult).catch(handleException);
}

function create(userId, year, month) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.post(`salaryspecification/user/${userId}/${year}/${month}`, null, requestOptions).then(handleResult).catch(handleException);
}

function update(salarySpecificationId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.patch(`salaryspecification/${salarySpecificationId}`, null, requestOptions).then(handleResult).catch(handleException);
}

function getDefinitions() {

    if (globalStore.salaryRowDefinitions) {
        console.log("Salary row definitions exists in cache");
        return new Promise((resolve) => resolve(globalStore.salaryRowDefinitions))
    }

    console.log("No Salary row definitions exists in cache, calling API");
    const requestOptions = {
        headers: authHeader()
    };

    return axios.get("salaryspecification/definitions", requestOptions).then(handleResult).then(p => {
        globalStore.salaryRowDefinitions = p;
        return p;
    }).catch(handleException);
}

function saveSalaryRow(salarySpecificationId, salaryRow) {
    const requestOptions = {
        headers: authHeader()
    };

    if (!salaryRow.id) {
        return axios.put(`/salaryspecification/${salarySpecificationId}/salaryRow`,
            salaryRow,
            requestOptions).then(handleResult);
    }

    return axios.patch(`/salaryspecification/${salarySpecificationId}/salaryrow/${salaryRow.id}`,
        salaryRow,
        requestOptions).then(handleResult).catch(handleException);
}

function deleteSalaryRow(salarySpecificationId, salaryRowId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.delete(`/salaryspecification/${salarySpecificationId}/salaryrow/${salaryRowId}`, requestOptions).then(handleResult).catch(handleException);
}

function getCalculationData(salaryRowId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.get("salaryspecification/calculationData/" + salaryRowId, requestOptions).then(handleResult).catch(handleException);
}

function getPdf(salarySpecification) {
        return axios({
          url: "salaryspecification/" + salarySpecification.id + "/pdf",
          method: "GET",
          headers: authHeader(),
          responseType: "blob" // important
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${salarySpecification.user.firstName} ${salarySpecification.user.lastName}.pdf`
          ); //or any other extension
          document.body.appendChild(link);
          link.click();

          return response;
        });
}

function getZip(date) {
    return axios({
      url: `salaryspecification/zip/${date}`,
      method: "GET",
      headers: authHeader(),
      responseType: "blob" // important
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "lönespecifikationer.zip"
      ); //or any other extension
      document.body.appendChild(link);
      link.click();

      return response;
    });
}

function attest(salarySpecificationId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.patch("salaryspecification/" + salarySpecificationId + "/attest", null, requestOptions).then(handleResult).catch(handleException);    
}

function lockToggle(salarySpecificationId, lock) {
    const requestOptions = {
        headers: authHeader()
    };

    var lockPath = "unlock";
    if(lock) lockPath = "lock";

    return axios.patch("salaryspecification/" + salarySpecificationId + "/" + lockPath, null, requestOptions).then(handleResult).catch(handleException);    
}
